import React, { useState, useRef } from 'react'
import { withStyles } from '@mui/styles'

import lang from 'lang'
import CheckIcon from 'assets/images/icons/check.svg'
import { ModalBig } from '@/modules/base/components/modal/index'
import { Checkbox, TabInput } from '@/modules/base/components/inputs/index'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import { CompanyFormFields, BaseFormFields, PersonFormFields } from '@/modules/base/components/forms/address-form/index'
import { customerTypes, DEFAULT_EMPTY_ADDRESS_OBJECT } from '@/modules/base/util/constants'
import { Title } from '@/modules/base/components/texts/index'

const { COMPANY, PERSON } = customerTypes
const SUPPLIER = 'supplier'
const TAB_INDICES = { [SUPPLIER]: 0, [COMPANY]: 1, [PERSON]: 2 }
const TAB_ITEMS = [SUPPLIER, COMPANY, PERSON]

const AddressFormModal = (props) => {
  const { onSubmit = () => { }, onCancel, classes, data, disableBackdropClick, onClose } = props
  const formErrors = { companyName: '', firstName: '' }
  const [updatedAddress, updateAddress] = useState({ ...DEFAULT_EMPTY_ADDRESS_OBJECT, isDefault: true, ...data, companyName: data.companyName || '', lastName: data.companyName || '' })
  const [addressKind, setAddressKind] = useState(SUPPLIER)
  const toggleRef = useRef(null)

  const title = addressKind === SUPPLIER
    ? lang.genericModules.supplierCustomerModal.createSupplier
    : lang.genericModules.supplierCustomerModal.createCustomer

  const submitButtonLabel = lang.generics.make

  const handleFieldChange = (value, name) => {
    updateAddress({ ...updatedAddress, [name]: value })
  }
  const handleBaseFieldChange = (data) => {
    updateAddress({ ...updatedAddress, ...data })
  }

  const handleSubmitClick = () => {
    if (!updatedAddress.companyName && !updatedAddress.lastName) return

    const updatedAddresses = [{ addressKind, ...updatedAddress }]

    onClose()
    onSubmit(updatedAddresses)
  }
  const handleAbortClick = () => {
    onCancel && onCancel()
  }

  const companyFields = (
    <CompanyFormFields errors={formErrors} onTextInputChange={handleFieldChange} data={updatedAddress} />
  )
  const personFields = (
    <PersonFormFields errors={formErrors} onTextInputChange={handleFieldChange} onSalutationChanged={handleFieldChange} onTitleChanged={handleFieldChange} data={updatedAddress} useFormik={false} />
  )
  const baseFields = (
    <BaseFormFields data={updatedAddress} onChange={handleBaseFieldChange} useFormik={false} />
  )

  const additonalSupplierFields = (
    <>
      <form onSubmit={(e) => { e.preventDefault() }}>
        <Checkbox
          name='isDefault'
          checked={updatedAddress.isDefault}
          disabled={updatedAddress.isDefault}
          onChange={handleFieldChange}>
          <span className={classes.checkboxLabel}>{lang.supplierDefaultAddress}</span>
        </Checkbox>
      </form>
    </>
  )
  const additonalCustomerFields = (
    <>
      <div className={classes.row}>
        <div className='col-xs-6'>
          <Checkbox
            checked={true}
            disabled={true}
            name='isDefaultBilling'
            onChange={handleFieldChange}
          >
            <span className={classes.checkboxLabel}>{lang.defaultInvoiceAddress}</span>
          </Checkbox>
        </div>
      </div>
      <div className={classes.row}>
        <div className='col-xs-6'>
          <Checkbox
            checked={true}
            disabled={true}
            name='isDefaultDelivery'
            onChange={handleFieldChange}
          >
            <span className={classes.checkboxLabel}>{lang.defaultDeliveryAddress}</span>
          </Checkbox>
        </div>
      </div>
    </>
  )

  const actions = [
    <CancelButton key="address-form-cancel" type='button' label={lang.generics.abort} onClick={handleAbortClick} />,
    <ButtonIconSquare
      key="address-form-submit"
      type='button'
      icon={CheckIcon}
      label={submitButtonLabel}
      disabled={!updatedAddress.companyName && !updatedAddress.lastName}
      customClass={classes.submitButton}
      onClick={handleSubmitClick} />,
  ]

  const titleEle = (<Title>{title}</Title>)

  return (
    <ModalBig
      open={true}
      firstchildpaddingtop="0"
      paddingtop="0"
      modalspace="0"
      actionClass={classes.actions}
      actions={actions}
      onClose={onClose}
      disableBackdropClick={disableBackdropClick}
      draggable
      showCloseIcon={false}>
      <TabInput
        ref={toggleRef}
        key='toggleSupplierCustomer'
        customClass={classes.tabInput}
        tabs={[
          { key: SUPPLIER, label: lang.genericModules.supplierCustomerModal.supplier, content: [titleEle, companyFields, baseFields, additonalSupplierFields], contentClass: classes.tabContent },
          { key: COMPANY, label: lang.genericModules.supplierCustomerModal.company, content: [titleEle, companyFields, baseFields, additonalCustomerFields], contentClass: classes.tabContent },
          { key: PERSON, label: lang.genericModules.supplierCustomerModal.private, content: [titleEle, personFields, baseFields, additonalCustomerFields], contentClass: classes.tabContent },
        ]}
        value={TAB_INDICES[addressKind] || 0}
        onChange={(value) => {
          setAddressKind(TAB_ITEMS[value])
          handleFieldChange(value === 'supplier' ? 'company' : TAB_ITEMS[value], 'kind')
        }
        }
      />
    </ModalBig>
  )
}

const styles = ({
  content: {
    padding: '32px 32px 0px',
  },
  tabContent: {
    padding: '32px 32px 0px',
  },
  actions: {
    padding: '30px 32px 32px',
  },
  checkboxLabel: {
    marginLeft: 15,
  },
  submitButton: {
    marginLeft: 15,
  },
  row: {
    display: 'flex',
    flex: '0 1 auto',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: '-0.5rem',
    marginLeft: '-0.5rem',
    marginBottom: 25,
    '& > div:first-of-type': {
      paddongRight: 25,
    },
    '& > div:last-of-type': {
      paddongLeft: 25,
    },
    '& > div:first-of-type:last-of-type': {
      paddingLeft: 7,
      paddingRight: 25,
    },
    '&.zipCodeAndCity': {
      paddingRight: 0,
      marginBottom: 0,
    },
    '&.zipCodeAndCity > div:first-of-type': {
      paddingRight: 7,
    },
    '&.zipCodeAndCity > div:last-of-type': {
      paddingLeft: 7,
      paddingRight: 25,
    },
  },
})

const SupplierCustomerAddressFormModal = withStyles(styles)(AddressFormModal)

export default SupplierCustomerAddressFormModal
